import { requestGet, requestPost } from '@/utils/request';

const api = {
    LIST: '/member/actor_list',
    AUDIT_PASS: '/member/actor_audit_pass',
    AUDIT_REJECT: '/member/actor_audit_reject',
    CANCEL: '/member/actor_cancel'
};

export function actorList(params) {
    return requestGet(api.LIST, params);
}

export function actorAuditPass(id) {
    return requestPost(api.AUDIT_PASS, { id });
}

export function actorAuditReject(id, message) {
    return requestPost(api.AUDIT_REJECT, { id, message });
}

export function actorCancel(id, message) {
    return requestPost(api.CANCEL, { id, message });
}
